module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Users</h1>\n<p>\n  Telegauge is <b>User</b> based. That is to say, to view a screen, a user must have an account with Telegauge. User accounts allow each visitor to be assigned a variety of permissions. For example, not every user should be able to edit (a.k.a. mangle) screens.\n</p>\n'+
((__t=(APP.Tools.icon( "users", "Icon for Users", "watermark")))==null?'':__t)+
'\n';
}
return __p;
};
